import React, { useEffect, useState } from 'react'
import * as S from '../styles'

import Password from '@/components/Inputs/Password'

import { PAGE_PATHS } from '@/services/paths'

import { isB2CAvailable } from '@/services/functions'
import { useTranslation } from 'react-i18next'

const FormSignin = props => {
  const {
    userNameState,
    userNameHandler,
    passwordState,
    passwordHandler,
    rememberState,
    rememberHandler,
    loginHandler,
    screenHandler,
    screenIds
  } = props

  const { t } = useTranslation()

  const [labelsEmail, setLabelsEmail] = useState('')
  const [labelsPassword, setLabelsPassword] = useState('')
  const [placeholdersEmail, setPlaceholdersEmail] = useState('')
  const [placeholdersPassword, setPlaceholdersPassword] = useState('')
  const [titlesLogin, setTitlesLogin] = useState('')
  const [titlesForgotPassword, setTitlesForgotPassword] = useState('')
  const [titlesSignup, setTitlesSignup] = useState('Signup')
  const [subtitlesSignin, setSubtitlesSignin] = useState('')
  const [buttonsEnter, setButtonsEnter] = useState('')
  const [buttonsRemember, setButtonsRemember] = useState('')
  const [messagesNoAccount, setMessagesNoAccount] = useState('')

  useEffect(() => {
    setLabelsEmail(t('labels.email'))
    setLabelsPassword(t('labels.password'))
    setPlaceholdersEmail(t('placeholders.email'))
    setPlaceholdersPassword(t('placeholders.password'))
    setTitlesLogin(t('titles.login'))
    setTitlesForgotPassword(t('titles.forgotPassword'))
    setTitlesSignup(t('titles.signup'))
    setSubtitlesSignin(t('subtitles.signin'))
    setButtonsEnter(t('buttons.enter'))
    setButtonsRemember(t('buttons.remember'))
    setMessagesNoAccount(t('messages.noAccount'))
  }, [t])

  const renderSignupButton = () => {
    if (!isB2CAvailable()) return
    return (
      <div className="account">
        <span>{messagesNoAccount}</span>
        <a href={PAGE_PATHS.signup} id="btn_signup">
          {titlesSignup}
        </a>
      </div>
    )
  }

  const switchToResetPassScreen = () => {
    passwordHandler('')
    screenHandler(screenIds.forgot_password)
  }

  const handleSubmit = e => {
    e.preventDefault()
    loginHandler(userNameState, passwordState, false)
  }

  return (
    <div id="signin">
      <div className="title">
        <h1>{titlesLogin}</h1>
        <h2>{subtitlesSignin}</h2>
      </div>

      <S.FormWrapper onSubmit={handleSubmit}>
        <section>
          <label>{labelsEmail}</label>
          <input
            id="inp_email_login"
            type="email"
            placeholder={placeholdersEmail}
            value={userNameState}
            onChange={e => userNameHandler(e.target.value)}
          />
        </section>

        <section>
          <label>{labelsPassword}</label>
          <Password
            id="inp_pass_login"
            placeholder={placeholdersPassword}
            inputState={passwordState}
            inputHandler={passwordHandler}
          />
        </section>

        <section id="reminders">
          <div className="flexbox v-centered h-spaced">
            <div className="flexbox v-centered mr-5">
              <input
                id="inp_remember"
                type="checkbox"
                aria-labelledby="label_remember"
                checked={rememberState}
                onChange={e => {
                  rememberHandler(e.target.checked)
                }}
              />
              <label id="label_remember">{buttonsRemember}</label>
            </div>
            <button
              id="btn_forgotpass"
              type="button"
              className="link-button"
              onClick={switchToResetPassScreen}
            >
              {titlesForgotPassword}
            </button>
          </div>
        </section>

        <button id="btn_login" type="submit" className="btn lg blue">
          {buttonsEnter}
        </button>
      </S.FormWrapper>

      {renderSignupButton()}
    </div>
  )
}

export default FormSignin
